export var canEditPlaylist = function (playlist) {
    return playlist.type !== "public";
};
export var canDeletePlaylist = function (playlist) {
    return playlist.canBeDeleted;
};
export var isPrivatePlaylist = function (playlist) {
    return playlist.type !== "private";
};
